var _path, _path2, _path3, _g, _path4;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgWallet = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4163 11.9218H13.3803C11.9576 11.9218 10.7996 10.7645 10.7988 9.3425C10.7988 7.919 11.9568 6.761 13.3803 6.76025H16.4163C16.7268 6.76025 16.9788 7.01225 16.9788 7.32275C16.9788 7.63325 16.7268 7.88525 16.4163 7.88525H13.3803C12.5771 7.886 11.9238 8.53925 11.9238 9.34175C11.9238 10.1435 12.5778 10.7968 13.3803 10.7968H16.4163C16.7268 10.7968 16.9788 11.0488 16.9788 11.3593C16.9788 11.6698 16.7268 11.9218 16.4163 11.9218Z",
    fill: "#593EF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7233 9.85791H13.4893C13.1788 9.85791 12.9268 9.60591 12.9268 9.29541C12.9268 8.98491 13.1788 8.73291 13.4893 8.73291H13.7233C14.0338 8.73291 14.2858 8.98491 14.2858 9.29541C14.2858 9.60591 14.0338 9.85791 13.7233 9.85791Z",
    fill: "#593EF1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_214_8",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 16,
    height: 15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2.75H16.479V16.1297H2V2.75Z",
    fill: "#593EF1",
    stroke: "#593EF1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_214_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.9985 2.875C3.86236 2.875 2.125 4.61236 2.125 6.7485V12.1313C2.125 14.2674 3.86236 16.0048 5.9985 16.0048H12.4815C14.6178 16.0048 16.3542 14.2673 16.3542 12.1313V6.7485C16.3542 4.61251 14.6178 2.875 12.4815 2.875H5.9985ZM12.4815 16.1297H5.9985C3.79439 16.1297 2 14.3354 2 12.1312V6.7485C2 4.5437 3.79434 2.75 5.9985 2.75H12.4815C14.6856 2.75 16.4793 4.54359 16.4793 6.7485V12.1312C16.4793 14.3355 14.6856 16.1297 12.4815 16.1297Z",
    fill: "#593EF1",
    stroke: "#593EF1"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.51312 6.77881H5.46387C5.15337 6.77881 4.90137 6.52681 4.90137 6.21631C4.90137 5.90581 5.15337 5.65381 5.46387 5.65381H9.51312C9.82362 5.65381 10.0756 5.90581 10.0756 6.21631C10.0756 6.52681 9.82362 6.77881 9.51312 6.77881Z",
    fill: "#593EF1"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWallet, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/wallet.68bc7756.svg";
export { ForwardRef as ReactComponent };